var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { Component } from 'react';
import { $, getElementInfo, isDOM, addRule, getDomRect } from './dom';
import { throttle, isNull, intersect } from '../utils';
import logger from './logger';
import InspectorPanel from '../panel';
var DomInspectorBase = function (_super) {
  __extends(DomInspectorBase, _super);
  function DomInspectorBase(props) {
    if (props === void 0) {
      props = {};
    }
    var _this = _super.call(this) || this;
    _this._doc = window.document;
    _this.root = props.root ? isDOM(props.root) ? props.root : $(props.root) : $('body');
    if (isNull(_this.root)) {
      logger.warn('Root element is null. Auto select body as root');
      _this.root = $('body');
    }
    _this.theme = props.theme || 'dom-inspector-theme-default';
    _this.exclude = props.exclude ? __spreadArray([], __read(props.exclude), false) : [];
    _this.overlay = {};
    _this.overlayId = '';
    _this.target = '';
    _this.destroyed = false;
    _this.maxZIndex = props.maxZIndex || 1;
    _this.state = {
      baseInfo: [],
      otherInfo: [],
      wcagInfo: {
        front: '',
        backgroundColor: ''
      }
    };
    _this._cachedTarget = '';
    _this._throttleOnMove = throttle(_this._onMove.bind(_this), 100);
    _this.baseInfoList = props.baseInfoList;
    _this._init();
    props.enable && _this.enable();
    return _this;
  }
  DomInspectorBase.prototype.fresh = function () {
    this.overlay.parent.setAttribute('style', "z-index: " + this.maxZIndex + ";");
  };
  DomInspectorBase.prototype.enable = function () {
    if (this.destroyed) return logger.warn('Inspector instance has been destroyed! Please redeclare it.');
    this.overlay.parent.style.display = 'block';
    this.root.addEventListener('mousemove', this._throttleOnMove);
  };
  DomInspectorBase.prototype.pause = function () {
    this.root.removeEventListener('mousemove', this._throttleOnMove);
  };
  DomInspectorBase.prototype.reset = function () {
    this._cachedTarget = '';
    this.overlay.parent.setAttribute('style', "z-index: " + this.maxZIndex + ";");
    this.target = null;
  };
  DomInspectorBase.prototype.disable = function () {
    this.reset();
    this.root.removeEventListener('mousemove', this._throttleOnMove);
  };
  DomInspectorBase.prototype.destroy = function () {
    this.destroyed = true;
    this.disable();
    this.root.removeChild(this.overlay.parent);
    this.overlay = {};
  };
  DomInspectorBase.prototype.getElementInfo = function (ele) {
    if (!isDOM(ele) && !this.target) return logger.warn('Target element is not found. Warning function name:%c getElementInfo', 'color: #ff5151');
    return getElementInfo(ele || this.target);
  };
  DomInspectorBase.prototype._init = function () {
    this.overlayId = "dom-inspector-" + Date.now();
    var parent = this._createElement('div', {
      id: this.overlayId,
      "class": "dom-inspector " + this.theme,
      style: "z-index: " + this.maxZIndex + ";"
    });
    this.overlay = {
      parent: parent,
      content: this._createSurroundEle(parent, 'content'),
      paddingTop: this._createSurroundEle(parent, 'padding padding-top'),
      paddingRight: this._createSurroundEle(parent, 'padding padding-right'),
      paddingBottom: this._createSurroundEle(parent, 'padding padding-bottom'),
      paddingLeft: this._createSurroundEle(parent, 'padding padding-left'),
      borderTop: this._createSurroundEle(parent, 'border border-top'),
      borderRight: this._createSurroundEle(parent, 'border border-right'),
      borderBottom: this._createSurroundEle(parent, 'border border-bottom'),
      borderLeft: this._createSurroundEle(parent, 'border border-left'),
      marginTop: this._createSurroundEle(parent, 'margin margin-top'),
      marginRight: this._createSurroundEle(parent, 'margin margin-right'),
      marginBottom: this._createSurroundEle(parent, 'margin margin-bottom'),
      marginLeft: this._createSurroundEle(parent, 'margin margin-left'),
      tips: this._createSurroundEle(parent, 'tips', '<div class="tip-content"></div><div class="triangle"></div>')
    };
    this.root.appendChild(parent);
    this.tipContent = parent.querySelector('.tip-content');
    this.tipTriangle = parent.querySelector('.triangle');
  };
  DomInspectorBase.prototype._createElement = function (tag, attr, content) {
    var ele = this._doc.createElement(tag);
    Object.keys(attr).forEach(function (item) {
      ele.setAttribute(item, attr[item]);
    });
    if (content) ele.innerHTML = content;
    return ele;
  };
  DomInspectorBase.prototype._createSurroundEle = function (parent, className, content) {
    var ele = this._createElement('div', {
      "class": className
    }, content);
    parent.appendChild(ele);
    return ele;
  };
  DomInspectorBase.prototype._onMove = function (e) {
    this.target = e.target;
    if (this.target === this._cachedTarget) return null;
    this._cachedTarget = this.target;
    if (e.target.id) return null;
    if (!e.target.classList.length) {
      var parentClassList = e.target.parentNode.classList;
      if (!parentClassList.length) return null;
      var matchParentClassNames = intersect(this.exclude, __spreadArray([], __read(parentClassList), false));
      if (matchParentClassNames.length) return null;
    }
    var matchClassNames = intersect(this.exclude, __spreadArray([], __read(e.target.classList), false));
    if (matchClassNames.length) return null;
    var elementInfo = getElementInfo(e.target);
    var contentLevel = {
      width: elementInfo.width,
      height: elementInfo.height
    };
    var paddingLevel = {
      width: elementInfo['padding-left'] + contentLevel.width + elementInfo['padding-right'],
      height: elementInfo['padding-top'] + contentLevel.height + elementInfo['padding-bottom']
    };
    var borderLevel = {
      width: elementInfo['border-left-width'] + paddingLevel.width + elementInfo['border-right-width'],
      height: elementInfo['border-top-width'] + paddingLevel.height + elementInfo['border-bottom-width']
    };
    var marginLevel = {
      width: elementInfo['margin-left'] + borderLevel.width + elementInfo['margin-right'],
      height: elementInfo['margin-top'] + borderLevel.height + elementInfo['margin-bottom']
    };
    addRule(this.overlay.parent, {
      display: 'block',
      width: marginLevel.width + "px",
      height: marginLevel.height + "px",
      top: elementInfo.top + "px",
      left: elementInfo.left + "px"
    });
    addRule(this.overlay.content, {
      width: contentLevel.width + "px",
      height: contentLevel.height + "px",
      top: elementInfo['margin-top'] + elementInfo['border-top-width'] + elementInfo['padding-top'] + "px",
      left: elementInfo['margin-left'] + elementInfo['border-left-width'] + elementInfo['padding-left'] + "px"
    });
    addRule(this.overlay.paddingTop, {
      width: paddingLevel.width + "px",
      height: elementInfo['padding-top'] + "px",
      top: elementInfo['margin-top'] + elementInfo['border-top-width'] + "px",
      left: elementInfo['margin-left'] + elementInfo['border-left-width'] + "px"
    });
    addRule(this.overlay.paddingRight, {
      width: elementInfo['padding-right'] + "px",
      height: paddingLevel.height - elementInfo['padding-top'] + "px",
      top: elementInfo['padding-top'] + elementInfo['margin-top'] + elementInfo['border-top-width'] + "px",
      right: elementInfo['margin-right'] + elementInfo['border-right-width'] + "px"
    });
    addRule(this.overlay.paddingBottom, {
      width: paddingLevel.width - elementInfo['padding-right'] + "px",
      height: elementInfo['padding-bottom'] + "px",
      bottom: elementInfo['margin-bottom'] + elementInfo['border-bottom-width'] + "px",
      right: elementInfo['padding-right'] + elementInfo['margin-right'] + elementInfo['border-right-width'] + "px"
    });
    addRule(this.overlay.paddingLeft, {
      width: elementInfo['padding-left'] + "px",
      height: paddingLevel.height - elementInfo['padding-top'] - elementInfo['padding-bottom'] + "px",
      top: elementInfo['padding-top'] + elementInfo['margin-top'] + elementInfo['border-top-width'] + "px",
      left: elementInfo['margin-left'] + elementInfo['border-left-width'] + "px"
    });
    addRule(this.overlay.borderTop, {
      width: borderLevel.width + "px",
      height: elementInfo['border-top-width'] + "px",
      top: elementInfo['margin-top'] + "px",
      left: elementInfo['margin-left'] + "px"
    });
    addRule(this.overlay.borderRight, {
      width: elementInfo['border-right-width'] + "px",
      height: borderLevel.height - elementInfo['border-top-width'] + "px",
      top: elementInfo['margin-top'] + elementInfo['border-top-width'] + "px",
      right: elementInfo['margin-right'] + "px"
    });
    addRule(this.overlay.borderBottom, {
      width: borderLevel.width - elementInfo['border-right-width'] + "px",
      height: elementInfo['border-bottom-width'] + "px",
      bottom: elementInfo['margin-bottom'] + "px",
      right: elementInfo['margin-right'] + elementInfo['border-right-width'] + "px"
    });
    addRule(this.overlay.borderLeft, {
      width: elementInfo['border-left-width'] + "px",
      height: borderLevel.height - elementInfo['border-top-width'] - elementInfo['border-bottom-width'] + "px",
      top: elementInfo['margin-top'] + elementInfo['border-top-width'] + "px",
      left: elementInfo['margin-left'] + "px"
    });
    addRule(this.overlay.marginTop, {
      width: marginLevel.width + "px",
      height: elementInfo['margin-top'] + "px",
      top: 0,
      left: 0
    });
    addRule(this.overlay.marginRight, {
      width: elementInfo['margin-right'] + "px",
      height: marginLevel.height - elementInfo['margin-top'] + "px",
      top: elementInfo['margin-top'] + "px",
      right: 0
    });
    addRule(this.overlay.marginBottom, {
      width: marginLevel.width - elementInfo['margin-right'] + "px",
      height: elementInfo['margin-bottom'] + "px",
      bottom: 0,
      right: elementInfo['margin-right'] + "px"
    });
    addRule(this.overlay.marginLeft, {
      width: elementInfo['margin-left'] + "px",
      height: marginLevel.height - elementInfo['margin-top'] - elementInfo['margin-bottom'] + "px",
      top: elementInfo['margin-top'] + "px",
      left: 0
    });
    var top = getDomRect(this.overlay.tips, e).top;
    this.getDomInfo();
    var isUp = top - this.tipContent.offsetHeight > 20;
    this.overlay.tips.style = '';
    if (isUp) {
      addRule(this.overlay.tips, {
        display: 'block',
        bottom: '100%'
      });
      this.tipTriangle.classList.remove('up');
      this.tipTriangle.classList.add('down');
    } else {
      addRule(this.overlay.tips, {
        display: 'block',
        top: '100%'
      });
      this.tipTriangle.classList.remove('down');
      this.tipTriangle.classList.add('up');
    }
  };
  DomInspectorBase.prototype.getDomInfo = function () {
    var computeStyle = window.getComputedStyle(this.target, null);
    var _a = this.target.getBoundingClientRect(),
      width = _a.width,
      height = _a.height;
    var baseInfo = this.baseInfoList.map(function (el) {
      if (el.type === 'baseStyle') return __assign({}, el);else if (el.type === 'boxSize') return __assign(__assign({}, el), {
        value: width + " \xD7 " + height + " px"
      });
      return __assign(__assign({}, el), {
        value: "" + computeStyle[el.type]
      });
    });
    this.setState({
      baseInfo: baseInfo,
      otherInfo: {
        tagName: this.target.tagName
      },
      wcagInfo: {
        front: computeStyle.color,
        backgroundColor: computeStyle.backgroundColor
      }
    });
  };
  DomInspectorBase.prototype.UNSAFE_componentWillReceiveProps = function (props) {
    var enable = props.enable,
      baseInfoList = props.baseInfoList;
    this.pause();
    this.baseInfoList = baseInfoList;
    if (enable) {
      this.enable();
    } else {
      this.disable();
    }
  };
  DomInspectorBase.prototype.componentWillUnmount = function () {
    this.destroy();
  };
  DomInspectorBase.prototype.render = function () {
    var _this = this;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InspectorPanel, {
      domClass: this.target ? __spreadArray([], __read(this.target.classList), false).map(function (item) {
        return "." + item;
      }).join('') : '',
      otherInfo: this.state.otherInfo,
      baseInfo: this.state.baseInfo,
      wcagInfo: this.state.wcagInfo,
      getContainer: function getContainer() {
        return _this.tipContent;
      }
    }));
  };
  return DomInspectorBase;
}(Component);
export default DomInspectorBase;